import { set } from "lodash";
import { PAYMENT_RECEIVER } from "utils/constants";

/** MANDAT « identique » : compte cotisations = Oui, autres comptes = Non. */
export const syncAcorisRefundMandatField = (values, isPayerReceiver) => {
  set(
    values,
    "project.fields.refundSameAsPayment",
    isPayerReceiver === PAYMENT_RECEIVER.SAME_ACCOUNT,
  );
};
